import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import apiService from '../services/api.service';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './FeaturedGallery.css';

const FeaturedGallery = () => {
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGalleries();
  }, []);

  const fetchGalleries = async () => {
    try {
      setLoading(true);
      const response = await apiService.getCmsGalleryPhotos({
        page: 1,
        pageSize: 6,
        sort: 'latest'
      });
      setGalleries(response.data.items || []);
    } catch (error) {
      console.error('Error fetching galleries:', error);
    } finally {
      setLoading(false);
    }
  };

  const sliderSettings = {
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1500,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    infinite: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  if (loading) {
    return (
      <div className="causes causes-loading">
        <div className="container">
          <div className="text-center">Loading galleries...</div>
        </div>
      </div>
    );
  }

  if (galleries.length === 0) {
    return null;
  }

  return (
    <div className="causes">
      <div className="container">
        <div className="section-header text-center">
          <p>Latest Gallery</p>
          <h2>Recent Exhibition Moments</h2>
        </div>
        <Slider {...sliderSettings}>
          {galleries.map((gallery) => (
            <Link key={gallery.slug} to={gallery.categorySlug ? `/gallery/${gallery.categorySlug}` : '/gallery'}>
              <div className="causes-item">
                <div className={`causes-img ${!gallery.imageUrl ? 'causes-img-placeholder' : ''}`}>
                  {gallery.imageUrl ? (
                    <img
                      src={gallery.imageUrl}
                      alt={gallery.altText || gallery.title}
                      onError={(event) => {
                        event.currentTarget.style.display = 'none';
                        event.currentTarget.parentElement.classList.add('causes-img-placeholder');
                      }}
                    />
                  ) : (
                    <div className="gallery-placeholder-content">
                      <i className="fas fa-images"></i>
                    </div>
                  )}
                  <div className="causes-overlay">
                    <div className="overlay-content">
                      <h4>{gallery.title}</h4>
                      <p>{gallery.categoryName}</p>
                      <span className="view-btn">View Gallery</span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </Slider>
        <div className="text-center" style={{ marginTop: '30px' }}>
          <Link to="/gallery" className="btn btn-primary">
            View All Galleries
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FeaturedGallery;
